<template>
    <!-- 单个专家 -->
    <div v-if="itemData" class="single-wapper">
        <div v-for="(item, index) in itemData" :key="index" class="expert-info" @click="onDoctorDetails(item)">
            <van-image :src="item.avatar" width="54" height="60" round fit="cover" />
            <div class="expert-info-right">
                <span>{{ item.name }}</span>
                <span>{{ item.position }}</span>
                <template v-for="(val, valIndex) in item.hospital_list">
                    <span v-if="val.hospital != ''" :key="valIndex">{{ val.hospital }} | {{ val.office }}</span>
                </template>
            </div>
        </div>
        <div style="width:100%;border-bottom: 1px solid #f5f5f5;padding:0px 18px;"></div>
    </div>
</template>

<script>
export default {
    props: {
        itemData: {
            type: Array,
            required: true
        }
    },
    methods: {
        onDoctorDetails(row = 1) {
            this.$router.push({ name: 'doctor-details', params: { id: row.id } })
        }
    }
}
</script>

<style lang="scss" scoped>
.single-wapper {
    background: #fff;
    padding: 24px 18px;
    padding-bottom: 0px;
    .expert-info {
        display: flex;
        padding-bottom: 24px;

        &-right {
            padding-left: 10px;
            display: flex;
            flex-direction: column;

            span {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #9d9d9d;
                letter-spacing: 0;

                &:nth-child(1) {
                    font-family: PingFangSC-Medium;
                    font-size: 15px;
                    color: #222222;
                    letter-spacing: 0;
                    line-height: 24px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/expertInfo/single.vue